export const regexValidator = {
  urlCR: new RegExp(/\b(?:https?:\/\/)?[^\/:]+\/.*?consumer-rights/),
  urlReviewsArticle: new RegExp(/\b(?:https?:\/\/)?[^\/:]+\/.*?reviews\/.*?\/article/),
  getBasicFilterQueryParams: new RegExp(/(filters((?!.nbf|.cat))+\w*([^&|?]*))/g),
  getNbfFilterQueryParams: new RegExp(/(filters.nbf)w*([^&]*)/g),
  getQueryParamValue: new RegExp(/=\s*(.*)$/),
  getFilterCategory: new RegExp(/filter.cat=w*([^&]*)/),
}
